/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Difficulty_HighInputs */

const en_us2_workout_after_difficulty_high = /** @type {(inputs: Workout_After_Difficulty_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very hard`)
};

const pt_br2_workout_after_difficulty_high = /** @type {(inputs: Workout_After_Difficulty_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito difícil`)
};

const es_419_workout_after_difficulty_high = /** @type {(inputs: Workout_After_Difficulty_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy difícil`)
};

const pt_pt2_workout_after_difficulty_high = /** @type {(inputs: Workout_After_Difficulty_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito difícil`)
};

const fr_fr2_workout_after_difficulty_high = /** @type {(inputs: Workout_After_Difficulty_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très difficile`)
};

const de_de2_workout_after_difficulty_high = /** @type {(inputs: Workout_After_Difficulty_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr schwer`)
};

const it_it2_workout_after_difficulty_high = /** @type {(inputs: Workout_After_Difficulty_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molto difficile`)
};

/**
* | output |
* | --- |
* | "Very hard" |
*
* @param {Workout_After_Difficulty_HighInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_difficulty_high = /** @type {((inputs?: Workout_After_Difficulty_HighInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Difficulty_HighInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_difficulty_high(inputs)
	if (locale === "es-419") return es_419_workout_after_difficulty_high(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_difficulty_high(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_difficulty_high(inputs)
	if (locale === "de-DE") return de_de2_workout_after_difficulty_high(inputs)
	if (locale === "it-IT") return it_it2_workout_after_difficulty_high(inputs)
	return en_us2_workout_after_difficulty_high(inputs)
});
export { workout_after_difficulty_high as "workout-after.difficulty_high" }